import Link from "../../Link";

const Angular = () => {
    return (
        <div>
            <Link url="https://campus.open-bootcamp.com/cursos/23" title={"OpenBootcamp Angular Básico"} />
            <Link url="https://campus.open-bootcamp.com/cursos/26" title={"OpenBootcamp Angular Avanzado"} />
        </div>
    );
}

export default Angular;